import {
  ChapterStatus
} from "../entities/trainingParticipant.js";
import {
  computeAggregatedAdherenceScore,
  computeCriterionScore
} from "./gradingAssessmentHelpers.js";
import { isNotNullNotUndefined, isNotUndefined } from "./utilities.js";
const minimumGradingRate = 0.5;
function computeChapterPassRate(assessmentTree, criteriaGrading) {
  return computeAggregatedAdherenceScore(
    { criteria_grading: criteriaGrading },
    assessmentTree
  );
}
function computeChapterAveragePassRate(assessmentTree, criteriaGradings) {
  const scores = criteriaGradings.map(
    (criteriaGrading) => criteriaGrading ? computeChapterPassRate(assessmentTree, criteriaGrading) : void 0
  ).filter(isNotNullNotUndefined);
  const scoreTotal = scores.reduce((acc, score) => acc + score, 0);
  const scoreCount = scores.length;
  if (scoreCount === 0 || scoreCount / criteriaGradings.length < minimumGradingRate) {
    return null;
  }
  return scoreTotal / scoreCount;
}
function computeChapterParticipationCount(participants, chapterId) {
  const completedTotal = participants.filter(
    (participant) => participant.course.chapters.some(
      (chapter) => chapter.id === chapterId && chapter.status === ChapterStatus.Completed
    )
  ).length;
  return completedTotal;
}
function computeChapterParticipationRate(participants, chapterId) {
  const participantTotal = participants.length;
  const completedTotal = computeChapterParticipationCount(
    participants,
    chapterId
  );
  if (participantTotal === 0) {
    return null;
  }
  return completedTotal / participantTotal;
}
function collectChapterGradingsForManyParticipants(participants, chapterId) {
  return participants.map(
    (participant) => participant.assessment?.chapters[chapterId]?.assessment_template?.criteria_grading
  );
}
function computeCriterionAverageScore(criterion, criteriaGradings) {
  const scores = criteriaGradings.map((grading) => computeCriterionScore(criterion, grading?.[criterion.id])).filter(isNotUndefined);
  const totalScore = scores.reduce((acc, score) => acc + score, 0);
  const totalCount = scores.length;
  if (totalCount === 0 || totalCount / criteriaGradings.length < minimumGradingRate) {
    return null;
  }
  return totalScore / totalCount;
}
export {
  collectChapterGradingsForManyParticipants,
  computeChapterAveragePassRate,
  computeChapterParticipationCount,
  computeChapterParticipationRate,
  computeChapterPassRate,
  computeCriterionAverageScore
};
//# sourceMappingURL=trainingAssessmentHelpers.js.map
